/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateFacilityServiceAreaUploadUrlResponse } from './CreateFacilityServiceAreaUploadUrlResponse';
import {
    CreateFacilityServiceAreaUploadUrlResponseFromJSON,
    CreateFacilityServiceAreaUploadUrlResponseFromJSONTyped,
    CreateFacilityServiceAreaUploadUrlResponseToJSON,
    CreateFacilityServiceAreaUploadUrlResponseToJSONTyped,
} from './CreateFacilityServiceAreaUploadUrlResponse';

/**
 * 
 * @export
 * @interface CreateFacilityServiceAreaUploadUrl200Response
 */
export interface CreateFacilityServiceAreaUploadUrl200Response {
    /**
     * 
     */
    data?: CreateFacilityServiceAreaUploadUrlResponse;
}

/**
 * Check if a given object implements the CreateFacilityServiceAreaUploadUrl200Response interface.
 */
export function instanceOfCreateFacilityServiceAreaUploadUrl200Response(value: object): value is CreateFacilityServiceAreaUploadUrl200Response {
    return true;
}

export function CreateFacilityServiceAreaUploadUrl200ResponseFromJSON(json: any): CreateFacilityServiceAreaUploadUrl200Response {
    return CreateFacilityServiceAreaUploadUrl200ResponseFromJSONTyped(json, false);
}

export function CreateFacilityServiceAreaUploadUrl200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFacilityServiceAreaUploadUrl200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CreateFacilityServiceAreaUploadUrlResponseFromJSON(json['data']),
    };
}

export function CreateFacilityServiceAreaUploadUrl200ResponseToJSON(json: any): CreateFacilityServiceAreaUploadUrl200Response {
    return CreateFacilityServiceAreaUploadUrl200ResponseToJSONTyped(json, false);
}

export function CreateFacilityServiceAreaUploadUrl200ResponseToJSONTyped(value?: CreateFacilityServiceAreaUploadUrl200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateFacilityServiceAreaUploadUrlResponseToJSON(value['data']),
    };
}

